import discoveryPNG from '~/assets/images/history/history-discovery-of-america.png'
import discoveryWEBP from '~/assets/images/history/history-discovery-of-america.webp'
import { EmojiRatingScalePage } from '~/shared/components/EmojiRatingScalePage'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION =
  'How would you rate your knowledge about the discovery of America?'

const RATING_OPTIONS = [
  { key: 'veryLow', emoji: '👎', fontSize: 24 },
  { key: 'low', emoji: '👎', fontSize: 16 },
  { key: 'neutral', emoji: '🤔', fontSize: 16 },
  { key: 'good', emoji: '👍', fontSize: 16 },
  { key: 'excellent', emoji: '👍', fontSize: 24 },
] as const

const DiscoveryOfAmerica = (props: TPageProps) => (
  <EmojiRatingScalePage
    {...props}
    ns="history"
    question={QUESTION}
    titleI18nKey="onboarding.historyDiscoveryOfAmerica.title"
    image={{
      png: discoveryPNG,
      webp: discoveryWEBP,
      alt: 'Discovery of America',
    }}
    options={RATING_OPTIONS}
  />
)

export default DiscoveryOfAmerica
